import { diseaseModalQueryBuilder } from '@/components/modals/DiseaseModal';

export const diseasesForResearchGroupQuery = diseaseModalQueryBuilder
  .filter(
    `references(*[_type == "researchGroup" && select(defined($slug) => slug.current == $slug, defined($id) => _id == $id, false)]._id)`
  )
  .use();
